import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './Component/home/home.component';
import { AboutUsComponent } from './Component/about-us/about-us.component';
import { ToursComponent } from './Component/tours/tours.component';
import { JoinOurTeamComponent } from './Component/join-our-team/join-our-team.component';
import { FacultyComponent } from './Component/faculty/faculty.component';
import { FacultyDetailsComponent } from './Component/faculty-details/faculty-details.component';
import { ContactUsComponent } from './Component/contact-us/contact-us.component';
import { EventDetailsComponent } from './Component/event-details/event-details.component';
import { LivestreamComponent } from './Component/livestream/livestream.component';
import { LoadingInterceptor } from './Shared/utils/loading.interceptor';
import { LoadingService } from './Services/loading.service';
import { LoadingComponent } from './Component/loading/loading.component';
import { OurRulesComponent } from './Component/our-rules/our-rules.component';
import { AgmCoreModule } from '@agm/core';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { NewsComponent } from './Component/news/news.component';
import { NewsDetailsComponent } from './Component/news-details/news-details.component';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutUsComponent,
    ToursComponent,
    JoinOurTeamComponent,
    FacultyComponent,
    FacultyDetailsComponent,
    ContactUsComponent,
    FacultyDetailsComponent,
    EventDetailsComponent,
    LivestreamComponent,
    LoadingComponent,
    OurRulesComponent,
    NewsComponent,
    NewsDetailsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDzts7e2X2qLZv0UyBDENuR3SJ5z26hpEE'
    }),
    AgmJsMarkerClustererModule,
    NgCircleProgressModule.forRoot({
      backgroundPadding: 0,
      radius: 100,
      space: -10,
      outerStrokeWidth: 10,
      innerStrokeWidth: 10,
      outerStrokeColor: "#007bff",
      innerStrokeColor: "#e7e8ea",
      animationDuration: 300,
      showTitle: true,
      showSubtitle: false,
      showUnits: true,
      showBackground: true,
      clockwise: true,
      startFromZero: false,
      showImage: false,
      imageSrc: 'assets/images/Logoheader.png',
      imageHeight: 50,
      imageWidth: 70,
      unitsFontSize: '30px',
      unitsColor: '#ffff',
      titleFontWeight: '30px',
      titleFontSize: '30px',
      titleColor:'#ffff'
    }),
  ],
  providers: [
    LoadingService,
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
